import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation, Trans } from "react-i18next";
import SocketContext from '../../Utils/socket-context';


class ManagerMenuConsumer extends Component {
	constructor(props) {
		super(props);

		

		this.state = {
			menuOpen: false
		}


		this.menuRef = React.createRef();
		this.blur = this.blur.bind(this);
		this.toggleMenu = this.toggleMenu.bind(this);

	}

	setReadNotifications() {

	}

	blur() {
		this.setState({menuOpen: false});
	}


	toggleMenu() {
		this.setState({menuOpen: !this.state.menuOpen});
		
	}


	componentDidUpdate(prev) {
		const that = this;

		if(this.props.socket && !prev.socket) {
			this.props.socket.on('test', function (data) {
				
				if(data.type && data.type === 'user_update')
					console.log('update user state')
			});
		}

	}

	componentDidMount() {
		const that = this;

		if(this.props.socket) {

			this.props.socket.on('test', function (data) {
				
				if(data.type && data.type === 'user_update')
					console.log('update user state')

			});
		}

	}

	render() {
		const menuOpen = this.state.menuOpen;
		
		return (
			<div>
				<span className={"msc"}>
				<ul className="header-menu">					
					<li><NavLink strict to="/manager/dashboard"><Trans i18nKey="menu_dashboard" /> </NavLink></li>
					<li><NavLink to="/task"><Trans i18nKey="label_tasks" /> </NavLink></li>
					<li><NavLink to="/manager/agents"><Trans i18nKey="label_agents" /> </NavLink></li>			
					{this.props.user.role === 'admin' && (<li><NavLink to="/payments"><Trans i18nKey="label_payment" /> </NavLink></li>)}		
					{/* <li><NavLink to="/manager/team">Teams </NavLink></li>
					<li><NavLink to="/settings">Settings </NavLink></li> */}
				</ul>
				</span>

				<ul className={"user-profile"} >
					<li>
					 
					
					{this.props.user.plan_type ? 
						this.props.user.plan_type === "prepaid" 
						? (<><span className={"user-plan btn btn-primary btn-sm"}>Balance : {this.props.user.plan_credit} DZD </span> <Link to={"/manager/fill"} className={"btn btn-link btn-sm mr-3"}><Trans i18nKey={"label_payment_type_prepaid"} /></Link></>) 
						: this.props.user.plan_type === 'free' 
							? (<><span className={"user-plan"}><Trans i18nKey={"label_plan_type_free"} /></span><Link to={"/plan/new"} className={"btn btn-link btn-sm mr-3"}><Trans i18nKey={"label_upgrade"} /></Link></>)
							: (<><span className={"user-plan"}><Trans i18nKey={"label_plan_type_subscribe"} /></span></>)
					: (<><span className={"user-plan"}><Trans i18nKey={"label_plan_type_free"} /></span><Link to={"/plan/new"} className={"btn btn-link btn-sm mr-3"}><Trans i18nKey={"label_upgrade"} /></Link></>)}
					


					<Trans i18nKey="signed_in_as" /> <span onClick={this.toggleMenu} className={"user-profile-username"}> {this.props.user.username}</span>
					<span className={"user-profile-notification"}>
					{this.props.notifications.filter(x => !x.read).length}

					<ul className={"notification-list"} onMouseEnter={this.props.setReadNotifications}>

						{this.props.notifications.length > 0 ? this.props.notifications.map(x => (

							<li key={x.id} className={x.read ? "" : "active"}>
							<a href="/">
								<span className={"notification-text"}>{x.content}</span>
								<span className={"notification-time"}>{x.datetime}</span>
							</a>
							</li>

						)) : "<li className={'notification-text'}>Aucune notification</li>" }

						
						

						
					</ul>
					</span>
					<span onClick={this.toggleMenu} className={"user-profile-avatar"}>
					{/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
					<img alt="Profile picture" src={this.props.user.picture ? "/img/"+this.props.user.picture : "/img/profile.jpg"} />
					</span>


					<ul  className={menuOpen === true ? "user-profile-menu open" : "user-profile-menu"} ref={this.menuRef} onBlur={this.blur}>
						<li><Link to="/account"><Trans i18nKey="my_account" /></Link></li>
						<li><Link to="/account/security"><Trans i18nKey="change_my_password" /></Link></li>

						<li><a href="javascript:void(0)"  onClick={e => this.props.logOut(false)} ><Trans i18nKey="logout" /></a></li>
						<li className={"sep"}></li>
						<li><Link to="/"><Trans i18nKey="help" /></Link></li>

					</ul>
					</li>
					<li><a href="#"></a></li>
				</ul>

				<div className={"clear"}></div>
			</div>
		)
	}
}

const ManagerTopMenu = props => (
	<SocketContext.Consumer>
		{socket => <ManagerMenuConsumer {...props} socket={socket} />}
	</SocketContext.Consumer>
  )

export default connect(null, null, null, { pure: false})(ManagerTopMenu)
